import AvatarCompany, {
  AvatarCompanyData,
} from "@/components/company/avatar-company";
import { useTranslation } from "@/hooks/useTranslation";
import { useState } from "react";
import { Trans } from "react-i18next";
import { GradientHighlight } from "./chat-new-greeting";

/**
 * Heading of a company chat's entry screen: the company's logo and a
 * commercial question naming it, as the company page shows its name. Same
 * type and gradient as the main chat's greeting, which it stands for here.
 */
export function ChatCompanyHomeHeader({
  company,
  name,
}: {
  company: AvatarCompanyData;
  /** The company's name as its page shows it. */
  name: string;
}) {
  const { t } = useTranslation();
  const variants = t("chat.companyHome.title.variants", {
    returnObjects: true,
  });
  const count = Array.isArray(variants) ? variants.length : 0;
  // Drawn once per opening, like the chat's own greeting: the question stays
  // put while the user reads, and the next opening may ask another one.
  const [draw] = useState(Math.random);
  const variantIndex = Math.floor(draw * count);

  return (
    <div className="flex flex-col items-center gap-3 text-center">
      <AvatarCompany company={company} className="size-12 border bg-muted" />
      {/* A long name wraps, then stops at three lines: the composer below
          must stay on screen in the narrowest side panel. */}
      {/* h2: the company page around the chat already holds the h1. */}
      <h2
        className="max-w-full text-2xl font-normal tracking-tight text-balance line-clamp-3 [overflow-wrap:anywhere]"
        title={name}
      >
        <Trans
          i18nKey={`chat.companyHome.title.variants.${variantIndex}`}
          values={{ company: name }}
          components={{ hl: <GradientHighlight /> }}
        />
      </h2>
      <p className="text-sm text-muted-foreground">
        {t("chat.companyHome.description")}
      </p>
    </div>
  );
}
